(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["huntdoor-camera-finder"] && !Shopify.designMode) return;
  try {
    
(() => {
  const tag = 'huntdoor-camera-builder';
  if (customElements.get(tag)) return;
  const copy = {
    fr: {steps:['Type de caméra','Caméra','Essentiels','Alimentation et solaire','Autres accessoires','Votre ensemble'],choose:'Choisir cette caméra',selected:'Sélectionnée',next:'Continuer',back:'Retour',review:'Voir mon ensemble',add:'Ajouter l’ensemble au panier',busy:'Vérification et ajout…',variant:'Variante',qty:'Quantité',include:'Ajouter cet accessoire',included:'Accessoire ajouté',empty:'Aucun accessoire compatible proposé à cette étape. Vous pouvez continuer.',optional:'Choisissez les accessoires dont vous avez besoin. Vous pouvez continuer sans ajout si vous êtes déjà équipé.',remove:'Retirer',edit:'Modifier',total:'Sous-total estimé',tax:'Livraison, taxes applicables et rabais calculés au panier ou au paiement.',subscription:'L’abonnement cellulaire Airasim est distinct du matériel et n’est pas inclus dans ce total.',pruned:'Certains accessoires ont été retirés, car ils ne sont plus compatibles avec la caméra choisie.',need:'Sélectionnez une caméra disponible pour continuer.',unavailable:'Cette variante est indisponible ou nécessite un achat sur sa fiche produit.',error:'Impossible de vérifier les produits. Réessayez dans un instant.',changed:'Le prix ou la disponibilité a changé. Vérifiez votre sélection avant de poursuivre.',cartError:'L’ajout n’a pas pu être confirmé. Consultez le panier avant de recommencer pour éviter un doublon.',cart:'Voir le panier',loading:'Chargement du configurateur…',failed:'Le configurateur n’a pas pu démarrer. Rechargez la page.',quantityError:'Vérifiez les quantités indiquées.',none:'Aucun modèle configuré pour cette catégorie.',skip:'Passer cette étape',step:'Étape',topBack:'← Retour',topNext:'Suivant →',cameraSelected:'Caméra sélectionnée',changeCamera:'Modifier',resetConfirm:'Revenir au choix de caméra effacera la caméra et les accessoires sélectionnés. Continuer?',decreaseQty:'Réduire la quantité',increaseQty:'Augmenter la quantité',recommended:'Compléments recommandés',recommendedDesc:'Selon vos choix, ces accessoires compatibles peuvent compléter votre installation.',dependentRemoved:'Certains compléments ont été retirés parce qu’ils ne sont plus disponibles selon vos sélections.',powerTitle:'Quel niveau d’utilisation prévoyez-vous?',powerIntro:'Choisissez votre niveau d’utilisation pour mettre en évidence les solutions d’alimentation les mieux adaptées. Les autres options compatibles demeurent disponibles.',powerBase:'Base',powerBaseDesc:'Utilisation occasionnelle et peu de déclenchements.',powerNormal:'Normale',powerNormalDesc:'Utilisation régulière avec davantage d’autonomie.',powerIntensive:'Intensive',powerIntensiveDesc:'Beaucoup d’activité, vidéo ou fonctions plus énergivores.',powerRecommended:'Recommandé pour votre utilisation',powerRecommendedDesc:'Ces solutions correspondent au niveau d’utilisation sélectionné.',powerOther:'Autres options compatibles',powerOtherDesc:'Ces produits demeurent compatibles, mais ne sont pas classés comme choix principal pour ce niveau.',powerHideOther:'Masquer les autres options compatibles',powerRecommendedFor:'Recommandé pour une utilisation {profile}',powerBadge:'Recommandé · {profile}',promoBadge:'PROMOTION',chooseBundle:'Choisir ce kit',kitSelected:'Kit sélectionné',solarIncludes:'Caméra + carte mémoire 32 Go + kit solaire 12 V + batterie 12 V 7,5 Ah',buildOwn:'Ou construisez votre propre kit',buildOwnDesc:'Choisissez ACCESS ou ACCESS-L et personnalisez ensuite votre installation.'},
    en: {steps:['Camera type','Camera','Essentials','Power and solar','Other accessories','Your kit'],choose:'Choose this camera',selected:'Selected',next:'Continue',back:'Back',review:'Review my kit',add:'Add kit to cart',busy:'Checking and adding…',variant:'Variant',qty:'Quantity',include:'Add this accessory',included:'Accessory added',empty:'No compatible accessories are offered at this step. You can continue.',optional:'Choose the accessories you need. You can continue without adding any if you already have them.',remove:'Remove',edit:'Edit',total:'Estimated subtotal',tax:'Shipping, applicable taxes and discounts calculated in the cart or at checkout.',subscription:'The Airasim cellular subscription is separate from the hardware and is not included in this total.',pruned:'Some accessories were removed because they are no longer compatible with your selected camera.',need:'Select an available camera to continue.',unavailable:'This variant is unavailable or requires purchase on its product page.',error:'Unable to check products. Please try again shortly.',changed:'Price or availability has changed. Review your selection before continuing.',cartError:'The cart addition could not be confirmed. Check your cart before starting again to avoid duplicates.',cart:'View cart',loading:'Loading camera finder…',failed:'The camera finder could not start. Reload the page.',quantityError:'Check the quantities entered.',none:'No models are configured for this category.',skip:'Skip this step',step:'Step',topBack:'← Back',topNext:'Next →',cameraSelected:'Selected camera',changeCamera:'Change',resetConfirm:'Returning to camera selection will clear the selected camera and accessories. Continue?',decreaseQty:'Decrease quantity',increaseQty:'Increase quantity',recommended:'Recommended complements',recommendedDesc:'Based on your selections, these compatible accessories can complete your setup.',dependentRemoved:'Some complements were removed because they are no longer available based on your selections.',powerTitle:'How will you use your camera?',powerIntro:'Choose your usage level to highlight the power solutions best suited to your needs. Other compatible options remain available.',powerBase:'Base',powerBaseDesc:'Occasional use with fewer triggers.',powerNormal:'Normal',powerNormalDesc:'Regular use with extended autonomy.',powerIntensive:'Intensive',powerIntensiveDesc:'High activity, video or more power-hungry features.',powerRecommended:'Recommended for your use',powerRecommendedDesc:'These power solutions match the selected usage level.',powerOther:'Other compatible options',powerOtherDesc:'These products remain compatible but are not classified as the primary choice for this level.',powerHideOther:'Hide other compatible options',powerRecommendedFor:'Recommended for {profile} use',powerBadge:'Recommended · {profile}',promoBadge:'PROMOTION',chooseBundle:'Choose this kit',kitSelected:'Selected kit',solarIncludes:'Camera + 32GB memory card + 12V solar kit + 12V 7.5Ah battery',buildOwn:'Or build your own kit',buildOwnDesc:'Choose ACCESS or ACCESS-L, then customize your setup.'}
  };
  function el(tag, text, cls) { const e=document.createElement(tag); if(text!==undefined)e.textContent=text; if(cls)e.className=cls; return e; }
  function parseRules(raw) {
    const map=new Map();
    raw.split(/\r?\n/).map(s=>s.trim()).filter(Boolean).forEach(line=>{
      const match=line.match(/^(\d+)\s*:\s*(.+)$/);
      if(match)map.set(match[1],match[2].split(',').map(s=>s.trim()).filter(Boolean));
    });
    return map;
  }
  class Builder extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;
      const start=()=>{
        if(!this.isConnected||this.ready)return;
        // A custom element can connect before the HTML parser reaches its products.
        // The last child marks a fully parsed section, including theme-editor inserts.
        if(!this.querySelector('[data-hd-ready]')) {
          if(!this.observer){this.observer=new MutationObserver(start);this.observer.observe(this,{childList:true,subtree:true});}
          return;
        }
        this.observer?.disconnect();this.observer=null;
        this.ready=true;
        try{this.init();}catch(e){const p=this.querySelector('[data-status]');if(p)p.textContent=this.dataset.lang==='fr'?copy.fr.failed:copy.en.failed;}
      };
      if(document.readyState==='loading'){
        this.onDocumentReady=start;
        document.addEventListener('DOMContentLoaded',start,{once:true});
      }else{start();}
    }
    disconnectedCallback(){
      this.observer?.disconnect();this.observer=null;
      if(this.onDocumentReady)document.removeEventListener('DOMContentLoaded',this.onDocumentReady);
    }
    init() {
      this.t=copy[this.dataset.lang]||copy.en;
      this.locale=this.dataset.lang==='fr'?'fr-CA':'en-CA';
      this.currency=this.dataset.currency||'CAD';
      this.money=new Intl.NumberFormat(this.locale,{style:'currency',currency:this.currency,currencyDisplay:'code'});
      this.products=new Map();this.blocks=[];
      this.querySelectorAll('[data-source]').forEach(source=>{
        const p=JSON.parse(source.dataset.product);if(!p||!p.id)return;
        p.url=source.dataset.url;p.requires_selling_plan=source.dataset.requiresPlan==='true';
        this.products.set(String(p.id),p);
        const stageValue=String(source.dataset.stage||'');
        const legacyComplement=stageValue==='complement';
        const parsedStage=Number(stageValue);
        const stage=[2,3,4].includes(parsedStage)?parsedStage:3;
        const triggerProductIds=Array.from(new Set((source.dataset.triggerProducts||'').split(',').map(s=>s.trim()).filter(Boolean)));
        this.blocks.push({
          id:source.dataset.key,
          kind:source.dataset.kind,
          productId:String(p.id),
          category:source.dataset.category,
          baseCamera:(source.dataset.baseCamera||'').trim(),
          points:(source.dataset.points||'').split(/\r?\n/).map(x=>x.trim()).filter(Boolean).slice(0,3),
          stage,
          modes:{
            access:this.normalizeMode(source.dataset.modeAccess,legacyComplement),
            access_l:this.normalizeMode(source.dataset.modeAccessL,legacyComplement),
            sg520:this.normalizeMode(source.dataset.modeSg520,legacyComplement),
            bg590:this.normalizeMode(source.dataset.modeBg590,legacyComplement),
            sg2060:this.normalizeMode(source.dataset.modeSg2060,legacyComplement)
          },
          triggerProductIds,
          required:source.dataset.required==='true',
          requirementGroup:(source.dataset.requirementGroup||'').trim(),
          requirementFr:source.dataset.requirementFr||'',
          requirementEn:source.dataset.requirementEn||'',
          coveredBy:(source.dataset.coveredBy||'').split(',').filter(Boolean),
          powerProfiles:[
            source.dataset.powerBase==='true'?'base':null,
            source.dataset.powerNormal==='true'?'normal':null,
            source.dataset.powerIntensive==='true'?'intensive':null
          ].filter(Boolean),
          raw:source.dataset.rules||'',
          rules:parseRules(source.dataset.rules||'')
        });
      });
      this.step=0;this.category=null;this.camera=null;this.items=new Map();this.ownedRequirements=new Map();this.powerProfile=null;this.powerOtherOpen=false;this.promoFocus=false;this.busy=false;this.submitted=false;
      this.analyticsMode=this.dataset.analyticsMode||'data_layer';this.finderId=this.dataset.finderId||'';
      this.panel=this.querySelector('[data-panel]');this.status=this.querySelector('[data-status]');
      this.progress=this.querySelector('[data-progress]');this.progressFill=this.querySelector('[data-progress-fill]');this.footer=this.querySelector('[data-footer]');
      this.topActions=this.querySelector('[data-top-actions]');
      this.querySelector('[data-choices]').hidden=false;
      this.querySelectorAll('[data-choice]').forEach(b=>{b.disabled=false;b.addEventListener('click',()=>{if(this.busy)return;this.category=b.dataset.choice;this.track('camera_type_selected',{camera_type:this.category,entry_source:'finder'});this.go(1);});});
      this.message('');
      const productPrefill=this.applyProductPagePrefill();
      const homepagePrefill=productPrefill?null:this.applyHomepagePrefill();
      const entrySource=productPrefill?'product_page':(homepagePrefill?.promo==='solar'?'solar_promo':(homepagePrefill?'homepage_kit':'finder'));
      this.render(false);
      this.track('camera_finder_start',{entry_source:entrySource});
      if(productPrefill){
        const p=this.product(productPrefill.block);
        this.track('camera_type_selected',{camera_type:this.category,entry_source:'product_page'});
        this.track('camera_selected',{camera_model:p?.title||'',camera_key:productPrefill.block.id,variant_id:String(productPrefill.variant.id),quantity:productPrefill.quantity,value:Number((((productPrefill.variant.price||0)*productPrefill.quantity)/100).toFixed(2)),entry_source:'product_page'});
      }else if(homepagePrefill){
        this.track('camera_type_selected',{camera_type:this.category,entry_source:'homepage_kit'});
      }
      this.trackStepView();
    }
    analyticsContext(extra={}){
      const cameraBlock=this.camera?this.block(this.camera.key):null;
      const cameraProduct=cameraBlock?this.product(cameraBlock):null;
      const stepKeys=['camera_type','camera','essentials','power_solar','other_accessories','your_kit'];
      return {
        finder_id:this.finderId,
        finder_language:this.dataset.lang||'en',
        step_number:this.step+1,
        step_key:stepKeys[this.step]||'',
        step_name:this.t.steps[this.step]||'',
        camera_type:this.category||'',
        camera_model:cameraProduct?.title||'',
        camera_key:this.camera?.key||'',
        power_profile:this.powerProfile||'',
        subtotal:Number((this.subtotal()/100).toFixed(2)),
        currency:this.currency,
        ...extra
      };
    }
    track(name,params={}){
      if(!name||this.analyticsMode==='off')return;
      const payload=this.analyticsContext(params);
      if(this.analyticsMode==='gtag'){
        window.dataLayer=window.dataLayer||[];
        window.gtag=window.gtag||function(){window.dataLayer.push(arguments);};
        window.gtag('event',name,payload);
        return;
      }
      window.dataLayer=window.dataLayer||[];
      window.dataLayer.push({event:name,...payload});
    }
    trackStepView(){
      this.track('finder_step_view');
      if(this.step===5)this.track('camera_finder_review',{item_count:this.entries().length,accessory_count:this.items.size,value:Number((this.subtotal()/100).toFixed(2))});
    }
    product(block){return this.products.get(block.productId);}
    normalizeMode(value,legacyComplement=false){
      const raw=String(value??'').trim().toLowerCase();
      if(raw==='direct'||raw==='complement'||raw==='both'||raw==='none')return raw;
      if(raw==='true'||raw==='1')return legacyComplement?'complement':'direct';
      return 'none';
    }
    modeFor(block){
      if(block?.kind!=='accessory'||!this.camera)return 'none';
      return block.modes?.[this.camera.key]||'none';
    }
    allowed(block,v) {
      if(block.kind==='camera'||block.kind==='bundle')return true;
      if(!this.camera||this.modeFor(block)==='none')return false;
      return block.raw.trim()?Boolean(block.rules.get(String(v.id))?.includes(this.camera.key)):true;
    }
    variants(block){return (this.product(block)?.variants||[]).filter(v=>this.allowed(block,v));}
    variant(block,id){return this.variants(block).find(v=>String(v.id)===String(id));}
    available(block,v){return Boolean(v?.available&&!this.product(block)?.requires_selling_plan);}
    block(id){return this.blocks.find(b=>b.id===id);}
    reachableItems(){
      const reached=new Set();
      this.items.forEach((item,key)=>{const b=this.block(key);if(b&&(item.origin!=='recommended'&&this.modeFor(b)!=='complement'||this.modeFor(b)==='both'))reached.add(key);});
      let changed=true;
      while(changed){changed=false;
        this.items.forEach((item,key)=>{const b=this.block(key);if(!b||reached.has(key))return;
          const ids=this.triggeringProductIds(b,reached);
          if(b.triggerProductIds.some(id=>ids.has(String(id)))){reached.add(key);changed=true;}
        });
      }
      return reached;
    }
    triggeringProductIds(target,reachable){
      const ids=new Set();
      if(this.camera)ids.add(String(this.block(this.camera.key)?.productId));
      this.items.forEach((item,key)=>{
        const b=this.block(key);
        if(b&&(!reachable||reachable.has(key))&&item.origin!=='recommended')ids.add(String(b.productId));
      });
      return ids;
    }
    canBeSuggested(block){
      const mode=this.modeFor(block);
      return mode==='complement'||mode==='both';
    }
    isSuggested(block){
      if(!this.canBeSuggested(block)||!block.triggerProductIds.length)return false;
      const selected=this.triggeringProductIds(block,this.reachableItems());
      return block.triggerProductIds.some(id=>selected.has(String(id)));
    }
    selectedBlocksByProduct(productId,target){
      return this.blocks.filter(b=>{
        if(String(b.productId)!==String(productId))return false;
        if(b.kind==='camera')return this.camera?.key===b.id;
        const item=this.items.get(b.id);
        return Boolean(item&&item.origin!=='recommended'&&this.reachableItems().has(b.id));
      });
    }
    triggerStages(block,seen=new Set()){
      const stages=new Set();
      if(!block||seen.has(block.id))return stages;
      if(block.kind==='camera'){stages.add(2);return stages;}
      const mode=this.modeFor(block);
      if((mode==='direct'||mode==='both')&&this.items.get(block.id)?.origin!=='recommended'){
        if(Number.isInteger(block.stage))stages.add(block.stage);
        return stages;
      }
      if(mode!=='complement'&&mode!=='both')return stages;
      const nextSeen=new Set(seen);nextSeen.add(block.id);
      block.triggerProductIds.forEach(productId=>{
        this.selectedBlocksByProduct(productId,block).forEach(triggerBlock=>{
          this.triggerStages(triggerBlock,nextSeen).forEach(stage=>stages.add(stage));
        });
      });
      if(!stages.size&&mode==='both')stages.add(block.stage);
      return stages;
    }
    suggestionStages(block,seen=new Set()){
      const stages=new Set();
      if(!block||!this.canBeSuggested(block)||seen.has(block.id))return stages;
      const nextSeen=new Set(seen);nextSeen.add(block.id);
      block.triggerProductIds.forEach(productId=>{
        this.selectedBlocksByProduct(productId,block).forEach(triggerBlock=>{
          this.triggerStages(triggerBlock,nextSeen).forEach(stage=>stages.add(stage));
        });
      });
      return stages;
    }
    isSuggestedAtStep(block,step){
      return this.isSuggested(block)&&this.suggestionStages(block).has(step);
    }
    editStep(block){
      const mode=this.modeFor(block);
      if(mode==='direct'||mode==='both')return Number.isInteger(block?.stage)?block.stage:2;
      const stages=Array.from(this.suggestionStages(block)).sort((a,b)=>a-b);
      return stages[0]||(Number.isInteger(block?.stage)?block.stage:2);
    }
    pruneComplements(){
      let removed=false,changed=true;
      while(changed){
        changed=false;
        this.items.forEach((item,key)=>{
          const b=this.block(key);
          if(b?.kind==='accessory'&&this.modeFor(b)==='complement'&&!this.reachableItems().has(key)){
            this.items.delete(key);
            removed=true;
            changed=true;
          }
        });
      }
      return removed;
    }
    requirementKey(b){return b.requirementGroup||b.id;}
    requirementPeers(b){return this.blocks.filter(x=>x.kind==='accessory'&&x.required&&this.requirementKey(x)===this.requirementKey(b)&&this.variants(x).length);}
    requirementSignature(b){
      const ids=new Set(this.requirementPeers(b).flatMap(x=>x.triggerProductIds));
      return JSON.stringify([this.camera?.key,this.entries().filter(x=>ids.has(String(x.block.productId))).map(x=>[x.block.productId,x.id,x.quantity]).sort()]);
    }
    requirementSatisfied(b){
      const peers=this.requirementPeers(b);
      const acceptable=new Set(peers.flatMap(x=>[String(x.productId),...x.coveredBy]));
      return this.entries().some(x=>acceptable.has(String(x.block.productId))&&this.available(x.block,this.variant(x.block,x.id)))||this.ownedRequirements.get(this.requirementKey(b))===this.requirementSignature(b);
    }
    activeRequirements(step){return this.blocks.filter(b=>b.required&&this.variants(b).length&&this.isSuggestedAtStep(b,step));}
    pendingRequirements(step){return this.activeRequirements(step).filter(b=>!this.requirementSatisfied(b));}
    checkRequirements(step){
      const pending=this.pendingRequirements(step);if(!pending.length)return true;
      this.message(this.dataset.lang==='fr'?'Vérifiez les compléments nécessaires : ajoutez une solution compatible ou confirmez que vous la possédez déjà.':'Check the required accessories: add a compatible option or confirm that you already own it.');
      const card=Array.from(this.panel.querySelectorAll('[data-requirement-notice]')).find(c=>c.dataset.requirementNotice===this.requirementKey(pending[0]));
      if(card){card.tabIndex=-1;card.focus({preventScroll:true});card.scrollIntoView({block:'center',behavior:'smooth'});}
      return false;
    }
    requirementNotice(block){
      const fr=this.dataset.lang==='fr',wrap=el('div',undefined,'hdcf__requirement');
      wrap.dataset.requirementNotice=this.requirementKey(block);
      const satisfied=this.requirementSatisfied(block);
      wrap.classList.toggle('is-satisfied',satisfied);
      wrap.append(el('strong',satisfied?(fr?'✓ Besoin couvert':'✓ Requirement covered'):(fr?'Complément nécessaire':'Required accessory')));
      const message=fr?block.requirementFr:block.requirementEn;
      wrap.append(el('p',message||(fr?'Ajoutez une solution compatible ou confirmez que vous en possédez déjà une pour cette installation.':'Add a compatible option or confirm that you already have one for this setup.')));
      const label=el('label',undefined,'hdcf__owned'),input=el('input');input.type='checkbox';
      input.checked=this.ownedRequirements.get(this.requirementKey(block))===this.requirementSignature(block);
      input.addEventListener('change',()=>{
        const key=this.requirementKey(block);
        if(input.checked)this.ownedRequirements.set(key,this.requirementSignature(block));else this.ownedRequirements.delete(key);
        this.message('');this.render(false);
      });
      label.append(input,el('span',fr?'Je possède déjà le nécessaire compatible pour cette installation.':'I already have the compatible equipment needed for this setup.'));
      wrap.append(label);return wrap;
    }
    matchesPowerProfile(block){
      return Boolean(this.powerProfile&&block?.stage===3&&block.powerProfiles?.includes(this.powerProfile));
    }
    powerProfileLabel(){
      if(this.powerProfile==='base')return this.t.powerBase;
      if(this.powerProfile==='normal')return this.t.powerNormal;
      if(this.powerProfile==='intensive')return this.t.powerIntensive;
      return '';
    }
    powerRecommendedTitle(){
      return this.t.powerRecommendedFor.replace('{profile}',this.powerProfileLabel());
    }
    powerBadgeLabel(){
      return this.t.powerBadge.replace('{profile}',this.powerProfileLabel());
    }
    renderPowerGuide(){
      const wrap=el('section',undefined,'hdcf__power-guide');
      wrap.append(el('h4',this.t.powerTitle));
      wrap.append(el('p',this.t.powerIntro));
      const choices=el('div',undefined,'hdcf__power-profiles');
      const profiles=[
        ['base',this.t.powerBase,this.t.powerBaseDesc],
        ['normal',this.t.powerNormal,this.t.powerNormalDesc],
        ['intensive',this.t.powerIntensive,this.t.powerIntensiveDesc]
      ];
      profiles.forEach(([key,title,description])=>{
        const b=el('button',undefined,'hdcf__power-profile');b.type='button';
        b.classList.toggle('is-selected',this.powerProfile===key);
        b.setAttribute('aria-pressed',this.powerProfile===key?'true':'false');
        b.append(el('strong',title),el('span',description));
        b.addEventListener('click',()=>{
          if(this.busy)return;
          const nextProfile=this.powerProfile===key?null:key;
          this.powerProfile=nextProfile;
          this.powerOtherOpen=false;
          this.track('power_profile_selected',{power_profile:nextProfile||key,selection_state:nextProfile?'selected':'cleared'});
          this.render(false);
        });
        choices.append(b);
      });
      wrap.append(choices);
      return wrap;
    }
    format(cents){return this.money.format(cents/100);}
    message(text){this.status.textContent=text;}
    button(text,fn,secondary=false){const b=el('button',text,secondary?'hdcf__back':'hdcf__link');b.type='button';b.disabled=this.busy;b.addEventListener('click',()=>{if(!this.busy)fn();});return b;}
    bundleBlock(){return this.camera?.bundleKey?this.block(this.camera.bundleKey):null;}
    purchaseBlock(){return this.bundleBlock()||this.block(this.camera?.key);}
    isSolarBundle(){return Boolean(this.camera?.bundleKey);}
    promoBundles(){
      if(this.dataset.solarEnabled!=='true')return [];
      return this.blocks.filter(b=>b.kind==='bundle'&&b.category==='cellular'&&b.baseCamera&&this.product(b));
    }
    chooseBundle(block,v,quantity){
      if(!this.available(block,v))return;
      const base=this.block(block.baseCamera);
      if(!base||base.kind!=='camera')return;
      const baseVariant=this.variants(base).find(x=>this.available(base,x))||this.variants(base)[0];
      if(!baseVariant)return;
      this.items.clear();
      this.ownedRequirements.clear();
      this.powerProfile=null;
      this.powerOtherOpen=false;
      this.camera={
        key:base.id,
        id:String(baseVariant.id),
        quantity,
        bundleKey:block.id,
        bundleId:String(v.id)
      };
      const p=this.product(block);
      this.track('solar_bundle_selected',{
        bundle_name:p?.title||'',
        bundle_product_id:String(p?.id||''),
        camera_key:base.id,
        variant_id:String(v.id),
        quantity,
        value:Number((((v.price||0)*quantity)/100).toFixed(2))
      });
      this.go(4);
    }
    bundleCard(block){
      const p=this.product(block),variants=this.variants(block);
      if(!p||!variants.length)return null;
      const current=variants.find(v=>this.available(block,v))||variants[0];
      const c=el('article',undefined,'hdcf__product hdcf__bundle-card');
      c.append(el('span',this.t.promoBadge,'hdcf__product-badge'));
      const src=p.featured_image?.src||p.featured_image;
      if(src){const img=el('img');img.src=src;img.alt=p.title;img.loading='lazy';c.append(img);}
      c.append(el('h4',p.title));
      c.append(el('p',this.t.solarIncludes,'hdcf__bundle-includes'));
      c.append(this.priceElement(current,1,'p','hdcf__price'));
      const note=el('p',this.t.unavailable);note.hidden=this.available(block,current);c.append(note);
      let quantity=1;
      const row=el('div',undefined,'hdcf__action-row hdcf__action-row--camera');
      const qty=this.qtyInput(quantity,n=>{quantity=n;});
      const actionCell=el('div',undefined,'hdcf__action-cell');
      actionCell.append(el('span',this.t.qty,'hdcf__field-label hdcf__field-label--ghost'));
      const action=this.button(this.t.chooseBundle,()=>this.chooseBundle(block,current,quantity));
      action.disabled=!this.available(block,current);
      actionCell.append(action);
      row.append(qty,actionCell);
      c.append(row);
      const link=el('a',this.dataset.lang==='fr'?'Détails du produit':'Product details','hdcf__details');
      link.href=p.url;link.target='_blank';link.rel='noopener';c.append(link);
      return c;
    }
    previousStep(){
      if(this.isSolarBundle()&&this.step===4)return 1;
      return Math.max(0,this.step-1);
    }
    resetCameraJourney(){
      this.camera=null;
      this.items.clear();this.ownedRequirements.clear();
      this.powerProfile=null;
      this.powerOtherOpen=false;
      this.submitted=false;
    }
    hasConfiguredJourney(){return Boolean(this.camera&&(this.isSolarBundle()||this.items.size>0||this.powerProfile));}
    normalizeCameraToken(value){return String(value||'').trim().toLowerCase().replace(/[^a-z0-9]/g,'');}
    applyHomepagePrefill(){
      const params=new URLSearchParams(window.location.search);
      const raw=String(params.get('kit')||'').trim().toLowerCase().replace(/[\s_-]/g,'');
      const promo=String(params.get('promo')||'').trim().toLowerCase().replace(/[\s_-]/g,'');
      let category=raw==='cellular'?'cellular':(raw==='noncellular'?'noncellular':null);
      if(promo==='solar'){
        category='cellular';
        this.promoFocus=true;
      }
      if(!category)return null;
      this.category=category;
      this.step=1;
      return {category,promo:promo==='solar'?'solar':''};
    }
    applyProductPagePrefill(){
      const params=new URLSearchParams(window.location.search);
      const productId=String(params.get('camera_id')||'').trim();
      const cameraToken=this.normalizeCameraToken(params.get('camera'));
      const variantId=String(params.get('variant')||params.get('variant_id')||'').trim();
      let quantity=parseInt(params.get('qty')||'1',10);
      if(!this.quantity(quantity))quantity=1;
      if(!productId&&!cameraToken)return null;
      let block=null;
      if(productId)block=this.blocks.find(b=>b.kind==='camera'&&String(b.productId)===productId)||null;
      if(!block&&cameraToken){
        block=this.blocks.find(b=>{
          if(b.kind!=='camera')return false;
          const p=this.product(b);
          return [b.id,p?.handle,p?.title].some(value=>this.normalizeCameraToken(value)===cameraToken);
        })||null;
      }
      if(!block)return null;
      const variants=this.variants(block);
      const variant=(variantId?variants.find(v=>String(v.id)===variantId&&this.available(block,v)):null)||variants.find(v=>this.available(block,v));
      if(!variant)return null;
      this.category=block.category;
      this.camera={key:block.id,id:String(variant.id),quantity};
      this.step=2;
      return {block,variant,quantity};
    }
    go(step){
      if(this.busy)return;
      if(step>this.step&&this.step>=2&&this.step<=4&&!this.checkRequirements(this.step))return;
      if(step===1&&this.step>1){
        if(this.hasConfiguredJourney()&&!window.confirm(this.t.resetConfirm))return;
        this.resetCameraJourney();
      }
      if(step>=2&&!this.camera){this.message(this.t.need);return;}
      this.step=step;this.message('');this.render();this.trackStepView();
    }
    choose(block,v,quantity){
      if(!this.available(block,v))return;
      this.camera={key:block.id,id:String(v.id),quantity};
      const cameraProduct=this.product(block);
      this.track('camera_selected',{camera_model:cameraProduct?.title||'',camera_key:block.id,variant_id:String(v.id),quantity,value:Number((((v.price||0)*quantity)/100).toFixed(2))});
      let removed=false;
      this.items.forEach((item,key)=>{const b=this.block(key);if(!b||!this.available(b,this.variant(b,item.id))){this.items.delete(key);removed=true;}});
      if(this.pruneComplements())removed=true;
      this.go(2);if(removed)this.message(this.t.pruned);
    }
    quantity(value){return Number.isInteger(Number(value))&&Number(value)>=1&&Number(value)<=99;}
    qtyInput(value,onchange){
      const wrap=el('div',undefined,'hdcf__field hdcf__qty-field');
      const labelText=el('span',this.t.qty,'hdcf__field-label');
      const stepper=el('div',undefined,'hdcf__qty-stepper');
      const minus=el('button','−','hdcf__qty-button');minus.type='button';minus.setAttribute('aria-label',this.t.decreaseQty);
      const input=el('input');input.type='number';input.min='1';input.max='99';input.step='1';input.inputMode='numeric';input.value=value;input.setAttribute('aria-label',this.t.qty);
      const plus=el('button','+','hdcf__qty-button');plus.type='button';plus.setAttribute('aria-label',this.t.increaseQty);
      const syncButtons=()=>{minus.disabled=this.busy||Number(value)<=1;plus.disabled=this.busy||Number(value)>=99;};
      const commit=next=>{
        if(!this.quantity(next)){input.reportValidity();input.value=value;this.message(this.t.quantityError);syncButtons();return;}
        value=Number(next);input.value=value;this.message('');syncButtons();onchange(value);
      };
      minus.addEventListener('click',()=>{if(!this.busy&&Number(value)>1)commit(Number(value)-1);});
      plus.addEventListener('click',()=>{if(!this.busy&&Number(value)<99)commit(Number(value)+1);});
      input.addEventListener('change',()=>commit(input.value));
      input.addEventListener('keydown',e=>{if(e.key==='Enter'){e.preventDefault();input.blur();}});
      stepper.append(minus,input,plus);wrap.append(labelText,stepper);syncButtons();return wrap;
    }
    card(block,presentation='direct',powerMatch=false){
      const p=this.product(block),isCam=block.kind==='camera',saved=isCam?(this.camera?.key===block.id?this.camera:null):this.items.get(block.id);
      const selectionOrigin=isCam?null:(saved?.origin||(presentation==='recommended'?'recommended':'direct'));
      const variants=this.variants(block);if(!variants.length)return null;
      const c=el('article',undefined,'hdcf__product');
      if(!isCam&&block.required&&this.isSuggestedAtStep(block,this.step))c.dataset.requirementCard=block.id;
      if(powerMatch&&!isCam){c.classList.add('is-power-match');c.append(el('span',this.powerBadgeLabel(),'hdcf__product-badge'));}
      const image=el('img');image.alt=p.title;image.loading='lazy';
      const src=p.featured_image?.src||p.featured_image;if(src){image.src=src;c.append(image);}
      c.append(el('h4',p.title));
      if(isCam){
        const points=el('ul',undefined,'hdcf__camera-points');
        const cameraPoints=(block.points||[]).slice(0,3);
        if(!cameraPoints.length)points.classList.add('is-empty');
        cameraPoints.forEach(point=>points.append(el('li',point)));
        c.append(points);
      }
      // Keep the finder simple: variants are not shown to the customer.
      // Automatically use the previously selected variant when valid; otherwise
      // use the first compatible available variant, then fall back to the first compatible variant.
      let current=variants.find(v=>String(v.id)===saved?.id&&this.available(block,v))||variants.find(v=>this.available(block,v))||variants[0];
      const price=this.priceElement(current,1,'p','hdcf__price');c.append(price);
      const note=el('p',this.t.unavailable);note.hidden=this.available(block,current);c.append(note);
      let quantity=saved?.quantity||1;
      const actionRow=el('div',undefined,`hdcf__action-row ${isCam?'hdcf__action-row--camera':'hdcf__action-row--accessory'}`);
      const quantityField=this.qtyInput(quantity,n=>{quantity=n;if(!isCam&&this.items.has(block.id)){const existing=this.items.get(block.id);this.items.set(block.id,{id:String(current.id),quantity,origin:existing?.origin||selectionOrigin});this.renderFooter();}});
      const actionCell=el('div',undefined,'hdcf__action-cell');
      const actionGhostLabel=el('span',this.t.qty,'hdcf__field-label hdcf__field-label--ghost');
      actionCell.append(actionGhostLabel);
      actionRow.append(quantityField,actionCell);
      let action,check;
      if(isCam){
        action=this.button(this.t.choose,()=>this.choose(block,current,quantity));
        action.disabled=!this.available(block,current);
        actionCell.append(action);
      }
      else {
        const row=el('label',undefined,'hdcf__include');
        check=el('input');check.type='checkbox';check.checked=Boolean(saved);check.disabled=!this.available(block,current);
        const includeIcon=el('span',check.checked?'✓':'+','hdcf__include-icon');
        const includeText=el('span',check.checked?this.t.included:this.t.include,'hdcf__include-text');
        const updateIncludeButton=()=>{
          row.classList.toggle('is-selected',check.checked);
          row.classList.toggle('is-disabled',check.disabled);
          includeIcon.textContent=check.checked?'✓':'+';
          includeText.textContent=check.checked?this.t.included:this.t.include;
          row.setAttribute('aria-label',includeText.textContent);
        };
        row.append(check,includeIcon,includeText);updateIncludeButton();actionCell.append(row);
        check.addEventListener('change',()=>{
          const analyticsItem={accessory_name:p.title,accessory_product_id:String(p.id),variant_id:String(current.id),quantity,source:selectionOrigin,value:Number((((current.price||0)*quantity)/100).toFixed(2))};
          if(check.checked){
            this.items.set(block.id,{id:String(current.id),quantity,origin:selectionOrigin});
            this.track('accessory_added',analyticsItem);
            if(selectionOrigin==='recommended')this.track('recommended_accessory_added',analyticsItem);
          }else{
            this.items.delete(block.id);
            this.track('accessory_removed',analyticsItem);
          }
          updateIncludeButton();
          const removed=this.pruneComplements();
          this.render(false);
          if(removed)this.message(this.t.dependentRemoved);
        });
      }
      c.append(actionRow);
      const link=el('a',this.dataset.lang==='fr'?'Détails du produit':'Product details','hdcf__details');link.href=p.url;link.target='_blank';link.rel='noopener';c.append(link);
      return c;
    }
    entries(){
      const entries=[];
      if(this.camera){
        const purchase=this.purchaseBlock();
        if(purchase){
          entries.push({
            block:purchase,
            id:this.isSolarBundle()?String(this.camera.bundleId):String(this.camera.id),
            quantity:this.camera.quantity,
            isCamera:true,
            isBundle:this.isSolarBundle()
          });
        }
      }
      this.items.forEach((item,key)=>entries.push({block:this.block(key),...item,isCamera:false,isBundle:false}));
      return entries;
    }
    priceElement(variant,quantity=1,tagName='span',className='hdcf__price-inline'){
      const wrap=el(tagName,undefined,className);
      const price=Number(variant.price);
      const compare=Number(variant.compare_at_price);
      const sale=Number.isFinite(compare)&&compare>price;
      const fr=this.dataset.lang==='fr';
      if(sale){
        const old=el('s',this.format(compare),'hdcf__price-old');
        old.setAttribute('aria-label',(fr?'Prix régulier : ':'Regular price: ')+this.format(compare));
        wrap.append(old);
      }
      const current=el('span',this.format(price),sale?'hdcf__price-sale':'hdcf__price-current');
      current.setAttribute('aria-label',(fr?'Prix de vente : ':'Selling price: ')+this.format(price));
      wrap.append(current);
      if(quantity>1)wrap.append(el('span',' × '+quantity+' = '+this.format(price*quantity),'hdcf__price-quantity'));
      return wrap;
    }
    subtotal(){return this.entries().reduce((sum,x)=>sum+(this.variant(x.block,x.id)?.price||0)*x.quantity,0);}
    payload(){
      const merged=new Map();
      this.entries().forEach(x=>{if(!this.available(x.block,this.variant(x.block,x.id))||!this.quantity(x.quantity))throw Error(this.t.changed);merged.set(x.id,(merged.get(x.id)||0)+x.quantity);});
      return {items:Array.from(merged,([id,quantity])=>({id,quantity}))};
    }
    selectedCameraSummary(){
      if(!this.camera)return null;
      const block=this.purchaseBlock();
      const p=this.product(block);
      const variantId=this.isSolarBundle()?this.camera.bundleId:this.camera.id;
      const v=this.variant(block,variantId);
      if(!block||!p)return null;
      const wrap=el('div',undefined,'hdcf__selected-camera');
      const info=el('div',undefined,'hdcf__selected-camera-info');
      info.append(el('span',this.isSolarBundle()?this.t.kitSelected:this.t.cameraSelected,'hdcf__selected-camera-label'));
      const details=el('div',undefined,'hdcf__selected-camera-details');
      details.append(el('strong',p.title));
      if(v){
        details.append(this.priceElement(v,this.camera.quantity,'span','hdcf__price-inline'));
      }
      info.append(details);
      const change=this.button(this.t.changeCamera,()=>this.go(1),true);
      change.classList.add('hdcf__selected-camera-change');
      wrap.append(info,change);
      return wrap;
    }
    render(focus=true){
      const activeGroups=new Map();
      [2,3,4].forEach(step=>this.activeRequirements(step).forEach(b=>activeGroups.set(this.requirementKey(b),this.requirementSignature(b))));
      this.ownedRequirements.forEach((signature,key)=>{if(activeGroups.get(key)!==signature)this.ownedRequirements.delete(key);});
      this.querySelector('[data-choices]').hidden=this.step!==0;this.panel.replaceChildren();
      this.classList.toggle('is-progressed',this.step>0);
      this.classList.toggle('is-essentials',this.step===2);
      const bundleProgress=this.isSolarBundle()&&this.step>=4;
      const progressCurrent=bundleProgress?(this.step===4?3:4):(this.step+1);
      const progressTotal=bundleProgress?4:6;
      this.progress.textContent=this.t.step+' '+progressCurrent+' / '+progressTotal+' · '+this.t.steps[this.step];
      if(this.progressFill)this.progressFill.style.width=((progressCurrent/progressTotal)*100)+'%';
      this.renderTopActions();
      if(this.step>0){
        const h=el('h3',this.t.steps[this.step]);h.tabIndex=-1;this.panel.append(h);
        if(this.step>=2&&this.step<=4&&this.camera){const cameraSummary=this.selectedCameraSummary();if(cameraSummary)this.panel.append(cameraSummary);}
        if(this.step===1){
          if(this.category==='cellular'){
            const promoBlocks=this.promoBundles();
            const promoCards=promoBlocks.map(b=>this.bundleCard(b)).filter(Boolean);
            if(promoCards.length){
              const promo=el('section',undefined,'hdcf__promo-section');
              const promoHead=el('div',undefined,'hdcf__promo-heading');
              const promoTitle=el('h4',this.dataset.solarTitle||'');
              promoTitle.tabIndex=-1;
              promoHead.append(promoTitle);
              if(this.dataset.solarIntro)promoHead.append(el('p',this.dataset.solarIntro));
              const promoGrid=el('div',undefined,'hdcf__promo-grid');
              promoCards.forEach(card=>promoGrid.append(card));
              promo.append(promoHead,promoGrid);
              this.panel.append(promo);
              const own=el('div',undefined,'hdcf__build-own');
              own.append(el('h4',this.t.buildOwn),el('p',this.t.buildOwnDesc));
              this.panel.append(own);
              if(this.promoFocus){
                this.promoFocus=false;
                requestAnimationFrame(()=>promo.scrollIntoView({block:'start'}));
              }
            }
          }
          const grid=el('div',undefined,'hdcf__products');
          const cameras=this.blocks.filter(b=>b.kind==='camera'&&b.category===this.category);
          cameras.forEach(b=>{const c=this.card(b);if(c)grid.append(c);});
          grid.classList.toggle('hdcf__camera-grid--has-points',cameras.some(b=>(b.points||[]).length));
          this.panel.append(grid);
          if(!cameras.length)this.panel.append(el('p',this.t.none));
          if(this.category==='cellular'&&this.dataset.compareUrl&&this.dataset.compareLabel){
            const compareWrap=el('div',undefined,'hdcf__compare-wrap');
            const compare=el('a',this.dataset.compareLabel+' ↗','hdcf__compare-button');
            compare.href=this.dataset.compareUrl;
            compare.target='_blank';
            compare.rel='noopener';
            compare.addEventListener('click',()=>this.track('camera_compare_click',{comparison:'ACCESS_vs_ACCESS-L'}));
            compareWrap.append(compare);
            this.panel.append(compareWrap);
          }
        }
        if(this.step>=2&&this.step<=4){
          if(!this.activeRequirements(this.step).length)this.panel.append(el('p',this.t.optional));
          if(this.step===3)this.panel.append(this.renderPowerGuide());
          const normal=this.blocks.filter(b=>{
            if(b.kind!=='accessory'||b.stage!==this.step)return false;
            const mode=this.modeFor(b);
            if(this.step===2&&this.isSuggestedAtStep(b,this.step))return true;
            if(mode==='direct')return true;
            if(mode==='both')return !this.isSuggestedAtStep(b,this.step);
            return false;
          });
          const suggested=this.blocks.filter(b=>
            b.kind==='accessory'&&!normal.includes(b)&&this.canBeSuggested(b)&&this.isSuggestedAtStep(b,this.step)
          );
          const shownRequirements=new Set();
          const appendRequirements=(container,blocks)=>{
            blocks.filter(b=>b.required&&this.isSuggestedAtStep(b,this.step)).forEach(b=>{
              const key=this.requirementKey(b);if(shownRequirements.has(key))return;
              shownRequirements.add(key);container.append(this.requirementNotice(b));
            });
          };
          appendRequirements(this.panel,normal);
          const suggestionCards=suggested.map(b=>this.card(b,'recommended')).filter(Boolean);

          if(this.step===3&&this.powerProfile){
            const recommendedBlocks=normal.filter(b=>this.matchesPowerProfile(b));
            const otherBlocks=normal.filter(b=>!this.matchesPowerProfile(b));
            const recommendedCards=recommendedBlocks.map(b=>this.card(b,'direct',true)).filter(Boolean);
            const otherCards=otherBlocks.map(b=>this.card(b,'direct',false)).filter(Boolean);

            // 1) Profile matches first.
            if(recommendedCards.length){
              this.panel.append(el('h4',this.powerRecommendedTitle(),'hdcf__group-title'));
              this.panel.append(el('p',this.t.powerRecommendedDesc,'hdcf__group-copy'));
              const grid=el('div',undefined,'hdcf__products');
              recommendedCards.forEach(card=>grid.append(card));
              this.panel.append(grid);
            }

            // 2) Triggered complements immediately after profile recommendations.
            if(suggestionCards.length){
              const wrap=el('section',undefined,'hdcf__suggestions');
              wrap.append(el('h4',this.t.recommended,'hdcf__suggestions-title'));
              if(!suggested.some(b=>b.required))wrap.append(el('p',this.t.recommendedDesc,'hdcf__suggestions-copy'));
              appendRequirements(wrap,suggested);
              const suggestionGrid=el('div',undefined,'hdcf__products');
              suggestionCards.forEach(card=>suggestionGrid.append(card));
              wrap.append(suggestionGrid);
              this.panel.append(wrap);
            }

            // 3) Compatible non-profile products stay compact unless they need to remain visible.
            if(otherCards.length){
              const otherHasSelected=otherBlocks.some(b=>this.items.has(b.id));
              const forceOpen=!recommendedCards.length||otherHasSelected;
              const otherOpen=forceOpen||this.powerOtherOpen;
              const section=el('section',undefined,'hdcf__power-other');

              if(forceOpen){
                section.classList.add('is-forced-open');
                section.append(el('h4',this.t.powerOther+' ('+otherCards.length+')','hdcf__group-title'));
                section.append(el('p',this.t.powerOtherDesc,'hdcf__group-copy'));
                const grid=el('div',undefined,'hdcf__products');
                otherCards.forEach(card=>grid.append(card));
                section.append(grid);
              }else{
                const toggle=el('button',undefined,'hdcf__other-toggle');
                toggle.type='button';
                toggle.setAttribute('aria-expanded',otherOpen?'true':'false');
                toggle.append(
                  el('span',(otherOpen?this.t.powerHideOther:this.t.powerOther)+' ('+otherCards.length+')'),
                  el('span',otherOpen?'−':'+','hdcf__other-toggle-icon')
                );
                toggle.addEventListener('click',()=>{
                  if(this.busy)return;
                  this.powerOtherOpen=!this.powerOtherOpen;
                  this.render(false);
                });
                section.append(toggle);
                if(otherOpen){
                  const panel=el('div',undefined,'hdcf__other-panel');
                  panel.append(el('p',this.t.powerOtherDesc,'hdcf__group-copy'));
                  const grid=el('div',undefined,'hdcf__products');
                  otherCards.forEach(card=>grid.append(card));
                  panel.append(grid);
                  section.append(panel);
                }
              }
              this.panel.append(section);
            }

            if(!recommendedCards.length&&!otherCards.length&&!suggestionCards.length)this.panel.append(el('p',this.t.empty));
          }else{
            const normalCards=normal.map(b=>this.card(b,'direct')).filter(Boolean);
            if(normalCards.length){
              const grid=el('div',undefined,this.step===4?'hdcf__products hdcf__products--balanced':'hdcf__products');normalCards.forEach(card=>grid.append(card));this.panel.append(grid);
            }
            if(suggestionCards.length){
              const wrap=el('section',undefined,'hdcf__suggestions');
              wrap.append(el('h4',this.t.recommended,'hdcf__suggestions-title'));
              if(!suggested.some(b=>b.required))wrap.append(el('p',this.t.recommendedDesc,'hdcf__suggestions-copy'));
              appendRequirements(wrap,suggested);
              const suggestionGrid=el('div',undefined,'hdcf__products');
              suggestionCards.forEach(card=>suggestionGrid.append(card));
              wrap.append(suggestionGrid);
              this.panel.append(wrap);
            }
            if(!normalCards.length&&!suggestionCards.length)this.panel.append(el('p',this.t.empty));
          }
        }
        if(this.step===5)this.summary();
        if(focus)h.focus();
      }
      this.renderFooter();
    }
    summary(){
      this.entries().forEach(x=>{
        const p=this.product(x.block),v=this.variant(x.block,x.id);
        const row=el('div',undefined,'hdcf__summary');
        const imageWrap=el('div',undefined,'hdcf__summary-image');
        const src=p.featured_image?.src||p.featured_image;
        if(src){const img=el('img');img.src=src;img.alt=p.title;img.loading='lazy';imageWrap.append(img);}
        const info=el('div',undefined,'hdcf__summary-info');
        info.append(el('strong',p.title));
        info.append(v?this.priceElement(v,x.quantity,'p','hdcf__price-line'):el('p',this.t.unavailable));
        const controls=el('div',undefined,'hdcf__summary-controls');
        const qty=el('div',undefined,'hdcf__summary-qty');
        qty.append(this.qtyInput(x.quantity,n=>{if(x.isCamera)this.camera.quantity=n;else this.items.get(x.block.id).quantity=n;this.render(false);}));

        const editCell=el('div',undefined,'hdcf__summary-action-cell');
        editCell.append(el('span',this.t.qty,'hdcf__field-label hdcf__field-label--ghost'));
        editCell.append(this.button(this.t.edit,()=>this.go(x.isCamera?1:this.editStep(x.block)),true));

        const removeCell=el('div',undefined,'hdcf__summary-action-cell');
        removeCell.append(el('span',this.t.qty,'hdcf__field-label hdcf__field-label--ghost'));
        if(!x.isCamera){
          removeCell.append(this.button(this.t.remove,()=>{
            const product=this.product(x.block),variant=this.variant(x.block,x.id);
            this.track('accessory_removed',{accessory_name:product?.title||'',accessory_product_id:String(product?.id||''),variant_id:String(x.id),quantity:x.quantity,source:x.origin||'direct',value:Number(((((variant?.price)||0)*x.quantity)/100).toFixed(2)),location:'your_kit'});
            this.items.delete(x.block.id);
            const removed=this.pruneComplements();
            this.render(false);
            if(removed)this.message(this.t.dependentRemoved);
          },true));
        }else{
          const placeholder=el('span',undefined,'hdcf__summary-action-placeholder');
          placeholder.setAttribute('aria-hidden','true');
          removeCell.append(placeholder);
        }
        controls.append(qty,editCell,removeCell);
        row.append(imageWrap,info,controls);
        this.panel.append(row);
      });
      const notes=el('div',undefined,'hdcf__summary-notes');
      notes.append(el('p',this.t.tax));
      if(this.block(this.camera.key)?.category==='cellular')notes.append(el('p',this.t.subscription));
      this.panel.append(notes);
      if(this.submitted){const link=el('a',this.t.cart,'hdcf__link');link.href=this.dataset.cartUrl;this.panel.append(link);}
    }
    clearCurrentAccessoryStep(){
      this.blocks.filter(b=>b.kind==='accessory'&&(
        ((this.modeFor(b)==='direct'||this.modeFor(b)==='both')&&b.stage===this.step)||
        (this.canBeSuggested(b)&&this.suggestionStages(b).has(this.step))
      )).forEach(b=>this.items.delete(b.id));
      this.pruneComplements();
    }
    appendStepNavigation(nav){
      if(this.step===0)return;
      nav.append(this.button(this.t.back,()=>this.go(this.previousStep()),true));
      if(this.step>=2&&this.step<=4){
        nav.append(this.button(this.step===4?this.t.review:this.t.next,()=>this.go(this.step+1)));
        if(!this.activeRequirements(this.step).length)nav.append(this.button(this.t.skip,()=>{this.track('finder_step_skipped');this.clearCurrentAccessoryStep();this.render(false);this.go(this.step+1);},true));
      }
      if(this.step===5){
        const b=this.button(this.busy?this.t.busy:this.t.add,()=>this.addCart());
        b.disabled=this.busy||this.submitted;
        nav.append(b);
      }
    }
    renderTopActions(){
      if(!this.topActions)return;
      this.topActions.replaceChildren();
      this.appendStepNavigation(this.topActions);
    }
    renderFooter(){
      this.footer.replaceChildren();if(this.step===0)return;
      if(this.camera){const total=el('div',undefined,'hdcf__footer-total');total.append(el('span',this.t.total),el('strong',this.format(this.subtotal())));this.footer.append(total);}
      if(this.camera)this.footer.append(el('p',this.dataset.lang==='fr'?'Sous-total avant les rabais supplémentaires admissibles, calculés au panier ou au paiement.':'Subtotal before eligible additional discounts, calculated in the cart or at checkout.','hdcf__discount-note'));
      const nav=el('div',undefined,'hdcf__nav');
      this.appendStepNavigation(nav);
      this.footer.append(nav);
    }
    async addCart(){
      if(this.busy||this.submitted||!this.camera)return;
      const requirementSteps=this.isSolarBundle()?[4]:[2,3,4];
      for(const step of requirementSteps){if(this.pendingRequirements(step).length){this.step=step;this.render();this.checkRequirements(step);return;}}
      this.busy=true;this.message('');this.renderFooter();this.renderTopActions();
      // Lock every edit while checking prices and sending the cart request.
      this.panel.querySelectorAll('button,input,select').forEach(x=>{x.disabled=true;});
      let sent=false;
      try {
        const oldTotal=this.subtotal();const selected=this.entries();
        const unique=Array.from(new Set(selected.map(x=>x.block.productId)));
        const fresh=await Promise.all(unique.map(async id=>{
          const p=this.products.get(id),u=new URL(p.url,location.origin);u.search='';u.hash='';u.pathname=u.pathname.replace(/\/$/,'')+'.js';
          const response=await fetch(u.pathname,{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error(this.t.error);
          const data=await response.json();if(String(data.id)!==id)throw Error(this.t.error);data.url=p.url;data.requires_selling_plan=data.requires_selling_plan||p.requires_selling_plan;return [id,data];
        }));
        fresh.forEach(([id,p])=>this.products.set(id,p));
        const payload=this.payload();if(this.subtotal()!==oldTotal)throw Error(this.t.changed);
        if(!payload.items.length)throw Error(this.t.need);
        sent=true;this.submitted=true;
        const r=await fetch(this.dataset.addUrl+'.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
        if(!r.ok)throw Error(this.t.cartError);
        this.track('camera_finder_complete',{item_count:selected.length,accessory_count:this.items.size,value:Number((this.subtotal()/100).toFixed(2))});
        await new Promise(resolve=>setTimeout(resolve,150));
        location.assign(this.dataset.cartUrl);
      }catch(e){
        this.message(sent?this.t.cartError:(e.message||this.t.error));
      }finally{
        this.busy=false;this.render(false);
      }
    }
  }
  customElements.define(tag,Builder);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pxu-before-after-image"] && !Shopify.designMode) return;
  try {
    
const { Section } = window.PxuThemeSections;

class BeforeAfterImageSection extends Section {
  constructor($root) {
    super($root);
    this.$root = $root;
    this.id = $root.id;
    this.data = this.loadData();
    this.onMount();
  }

  onMount() {
    this.compareWrapper = this.$root.querySelector('.pxu-before-after-image__compare-wrapper');
    this.cursor = this.$root.querySelector('.pxu-before-after-image__cursor');
    
    if (this.compareWrapper && this.cursor) {
      this.initEventListeners();
      this.initIntersectionObserver();
    }
  }

  onUnmount() {
    this.events.unregisterAll();
  }

  initIntersectionObserver() {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            observer.unobserve(this.compareWrapper);
            this.animateInitialPosition();
          }
        });
      },
      {
        rootMargin: '0px',
        threshold: 0.33
      }
    );

    observer.observe(this.compareWrapper);
  }

  initEventListeners() {
    this.events.register(this.compareWrapper, 'pointerdown', this.handlePointerDown.bind(this));
    this.events.register(this.compareWrapper, 'gotpointercapture', (e) => {
      this.compareWrapper.setPointerCapture(e.pointerId);
    });

    this.events.register(this.cursor, 'keydown', this.handleKeyboardNav.bind(this));

    this.events.register(this.compareWrapper, 'touchstart', (e) => {
      if (e.target === this.cursor || this.cursor.contains(e.target)) {
        e.preventDefault();
      }
    }, { passive: false });
  }

  handlePointerDown(event) {
    if (event.target.tagName === 'A') return;

    event.preventDefault();
    
    const isMobile = window.matchMedia('(max-width: 859px)').matches;
    const isTouch = event.pointerType === 'touch';
    const isOnCursor = event.target === this.cursor || this.cursor.contains(event.target);
    
    if (isMobile && isTouch && !isOnCursor) {
      return;
    }
    
    this.isDragging = true;
    this.compareWrapper.setPointerCapture(event.pointerId);
    
    const handlePointerMove = (e) => {
      if (!this.isDragging || e.buttons === 0) {
        this.events.unregister(this.compareWrapper, 'pointermove', handlePointerMove);
        return;
      }
      
      if (isMobile && isTouch && !isOnCursor) {
        return;
      }
      
      this.updateSliderPosition(e);
    };
    
    this.events.register(this.compareWrapper, 'pointermove', handlePointerMove);
    this.events.register(this.compareWrapper, 'pointerup', () => {
      this.isDragging = false;
      this.events.unregister(this.compareWrapper, 'pointermove', handlePointerMove);
    }, { once: true });
    
    if (!isMobile || !isTouch || isOnCursor) {
      this.updateSliderPosition(event);
    }
  }

  handleKeyboardNav(event) {
    const isVertical = this.compareWrapper.hasAttribute('data-vertical');
    const isValidKey = isVertical 
      ? ['ArrowUp', 'ArrowDown'].includes(event.code)
      : ['ArrowLeft', 'ArrowRight'].includes(event.code);
    
    if (!this.cursor.contains(event.target) || !isValidKey) return;

    event.preventDefault();
    
    const currentPosition = this.getCurrentPosition();
    const step = 1;
    const isDecreasing = isVertical ? event.code === 'ArrowUp' : event.code === 'ArrowLeft';
    
    this.updatePosition(currentPosition + (isDecreasing ? -step : step));
  }

  getCurrentPosition() {
    const position = parseFloat(getComputedStyle(this.compareWrapper).getPropertyValue('--before-after-cursor-position'));
    return isNaN(position) 
      ? parseFloat(getComputedStyle(this.$root).getPropertyValue('--before-after-initial-cursor-position'))
      : position;
  }

  updateSliderPosition(event) {
    const rect = this.compareWrapper.getBoundingClientRect();
    const isVertical = this.compareWrapper.hasAttribute('data-vertical');
    
    const percentage = isVertical
      ? ((event.clientY - rect.top) / rect.height) * 100
      : ((event.clientX - rect.left) / rect.width) * 100;

    this.updatePosition(document.dir === 'rtl' ? 100 - percentage : percentage);
  }

  updatePosition(percentage) {
    const boundedPercentage = Math.min(Math.max(percentage, 0), 100);
    this.compareWrapper.style.setProperty('--before-after-cursor-position', `${boundedPercentage}%`);
  }

  animateInitialPosition() {
    this.compareWrapper.style.setProperty('--before-after-cursor-position', '0%');
    
    setTimeout(() => {
      const startPosition = 0;
      const endPosition = parseFloat(getComputedStyle(this.$root).getPropertyValue('--before-after-initial-cursor-position'));
      const duration = 500;
      const startTime = performance.now();

      const animate = (currentTime) => {
        const progress = Math.min((currentTime - startTime) / duration, 1);
        const easeProgress = 1 - Math.pow(1 - progress, 2);
        
        this.updatePosition(startPosition + (endPosition - startPosition) * easeProgress);

        if (progress < 1) requestAnimationFrame(animate);
      };

      requestAnimationFrame(animate);
    }, 100);
  }
}

document.querySelectorAll('[data-pxu-before-after-image]').forEach(($section) => {
  Section.init($section, BeforeAfterImageSection);
});

// export class for theme editor instance management
if (Shopify.designMode) {
  window.PxuThemeSections.BeforeAfterImageSection = BeforeAfterImageSection;
}
  } catch(e) { console.error(e); }
})();
})();
